import { useTranslation } from 'services/hooks';
import './style.css';

const UserDetails = ({ user }) => {
	const getTranslation = useTranslation();
	const TRANSLATION_KEY = 'management_panel';

	return (
		<div className="UserDetails">
			<div className="UserDetails__data">
				<div className="UserDetails__row">
					{`${getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_user_details_name_row`)} ${user.fname || 'unknown'} ${
						user.lname || 'unknown'
					}`}
				</div>
				<div className="UserDetails__row">
					{`${getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_user_details_email_row`)} ${user.email || 'unknown'}`}
				</div>
				<div className="UserDetails__row">
					{`${getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_user_details_phone_row`)} ${user.phone || 'unknown'}`}
				</div>
			</div>
		</div>
	);
};
export default UserDetails;
